<div class="trustee-component">

  @for (trusteeFormGroup of trusteeFormGroups(); track trusteeFormGroup; let index = $index) {
    <div [class.trustee-card]="kybMode">
      <div class="row">
        <div class="col-12">
          <div class="trustee-card__header">
            <div class="application-subsection-title trustee-card__title">Trustee {{index + 1}}</div>
            @if (index === 0) {
              <div class="mat-body separator-bottom trustee-card__note">Minimum 1 trustee required</div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-12">
          <mat-button-toggle-group
            [hideSingleSelectionIndicator]="true"
            [hideMultipleSelectionIndicator]="true"
            [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'type')">
            <mat-button-toggle value="Entity">Entity Trustee</mat-button-toggle>
            <mat-button-toggle value="Individual">Individual Trustee</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <!-- INDIVIDUAL -->
      @if (trusteeFormGroupFormControl(trusteeFormGroup, 'type').value === 'Individual' &&
        (trusteeFormGroupFormControl(trusteeFormGroup, 'firstName') || trusteeFormGroupFormControl(trusteeFormGroup, 'individual'))) {
        @if (kybMode) {
          <div>
            @if (isKybIndividualComplete(trusteeFormGroup)) {
              <table class="kyb-people-table separator-bottom">
                <thead>
                  <tr>
                    <th class="col-select"></th>
                    <th class="col-name">Name</th>
                    <th class="col-role">Business Role</th>
                    <th class="col-ownership">Ownership %</th>
                    <th class="col-tick">Guarantor</th>
                    <th class="col-tick">Signer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="col-select"><mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox></td>
                    <td class="col-name">{{ kybIndividualName(trusteeFormGroup) }}</td>
                    <td class="col-role">Trustee</td>
                    <td class="col-ownership">-</td>
                    <td class="col-tick"><mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox></td>
                    <td class="col-tick"><mat-checkbox [checked]="true" [disabled]="true"></mat-checkbox></td>
                  </tr>
                </tbody>
              </table>
            }
            <div class="row separator-bottom">
              <div class="col-12">
                <button mat-stroked-button class="mr-2" (click)="openKybIndividualDialog(trusteeFormGroup)">
                  <span class="mdi mdi-pencil" matPrefix></span>
                  {{ isKybIndividualComplete(trusteeFormGroup) ? 'Edit details' : 'Enter details' }}
                </button>
                @if (canRemoveTrustee()) {
                  <button mat-stroked-button color="warn" (click)="removeTrustee(trusteeFormGroup)">Remove Trustee</button>
                }
              </div>
            </div>
          </div>
        } @else {
        <div>
          <div class="row">
            <div class="col-12">
              <individual-form
                [mark]="markObservable"
                [showAddressForm]="showAddressForm"
                [showIdentification]="showIdentification"
                [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'individual')">
              </individual-form>
            </div>
          </div>
          @if (canRemoveTrustee()) {
            <div class="row separator-bottom">
              <div class="col-12">
                <button mat-stroked-button color="warn" (click)="removeTrustee(trusteeFormGroup)">Remove Trustee</button>
              </div>
            </div>
          }
          @if (!kybMode && showAssetsAndLiabilities) {
            <div>
              <personal-assets
                [mark]="markObservable"
                (events)="onPersonalAssetEvent($event, trusteeFormGroup)"
              [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'personalAssets')"></personal-assets>
            </div>
          }
          <!-- row #8 -->
          @if (!kybMode && showAssetsAndLiabilities) {
            <div>
              <personal-liabilities
                [mark]="markObservable"
                (events)="onPersonalLiabilitiesEvent($event, trusteeFormGroup)"
              [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'personalLiabilities')"></personal-liabilities>
            </div>
          }
        </div>
        }
      }
      <!-- ENTITY -->
      @if (trusteeFormGroupFormControl(trusteeFormGroup, 'type').value === 'Entity' &&
        trusteeFormGroupFormControl(trusteeFormGroup, 'organisation')) {
        <div>
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <mat-checkbox color="primary" class="mb-3" [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'manualEntry')">Enter ACN
              Manually</mat-checkbox>
            </div>
          </div>
          <div class="row">
            @if (!trusteeFormGroup.get('manualEntry')?.value) {
              <div class="col-lg-6 col-md-12">
                <business-number-search [title]="'Trustee company’s ACN number'" [mark]="markObservable"
                  [searchFn]="businessNumberSearchFn"
                [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'organisation')"></business-number-search>
              </div>
            }
            <div class="col-lg-3 col-md-12">
              <entity-type [mark]="markObservable" [readonly]="entityTypeReadonly"
              [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'organisationType')"></entity-type>
            </div>
          </div>
          <!-- MANUAL ENTTRY-->
          @if (trusteeFormGroup.get('manualEntry')?.value) {
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <acn [isMandatory]="true" [mark]="markObservable" [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'stepacn')">
                </acn>
              </div>
              <div class="col-lg-4 col-md-12">
                <name title="Business name" [mark]="markObservable" [formControl]="trusteeFormGroupFormControl(trusteeFormGroup, 'businessName')">
                </name>
              </div>
            </div>
          }
          @if (canRemoveTrustee()) {
            <div class="row separator-bottom">
              <div class="col-12">
                <button mat-stroked-button color="warn" (click)="removeTrustee(trusteeFormGroup)">Remove Trustee</button>
              </div>
            </div>
          }
          @if (kybMode) {
            @if (!hasNestedParties(trusteeFormGroup)) {
              <div class="row separator-bottom">
                <div class="col-12">
                  <button mat-stroked-button (click)="toggleSigners(trusteeFormGroup)">
                    <span class="mdi mdi-account-check" matPrefix></span>
                    Select signers
                  </button>
                </div>
              </div>
              @if (isSignersVisible(trusteeFormGroup)) {
                <div class="row separator-bottom">
                  <div class="col-12">
                    @if (signerEntity(trusteeFormGroup); as trusteeSignerEntity) {
                      @if (trusteeSignerEntity.entity.mode === 'MANUAL') {
                        <manual-kyb-people
                          [commercialEntityId]="trusteeSignerEntity.entity.commercialEntityId"
                          [initialPeople]="trusteeSignerEntity.entity.manualPeople"
                          [showWaitingMessage]="showManualWaitingMessage(trusteeSignerEntity)"
                          (peopleChange)="manualPeopleChange.emit({commercialEntityId: trusteeSignerEntity.entity.commercialEntityId, people: $event})"
                          (validChange)="manualValidityChange.emit({commercialEntityId: trusteeSignerEntity.entity.commercialEntityId, valid: $event})">
                        </manual-kyb-people>
                      } @else if (trusteeSignerEntity.status === 'resolved') {
                        <kyb-entity-section
                          [entity]="trusteeSignerEntity.entity"
                          [entityType]="signerEntityType"
                          [forceShowPeople]="true"
                          [showHeader]="false"
                          [allowManualEntry]="allowManualEntry"
                          [guarantorLockedStakeholderIds]="guarantorLockedStakeholderIds"
                          (personRoleChange)="personRoleChange.emit($event)"
                          (personSelectedChange)="personSelectedChange.emit($event)"
                          (manualEntry)="startManualKyb(trusteeSignerEntity)">
                        </kyb-entity-section>
                      } @else {
                        <!-- The run is still in flight or stalled. kyb-status owns the wait for this
                             company's own check, exactly as the company details step does for the
                             applicant: it polls until the check lands, and its Retry pulls the
                             execution from FrankieOne rather than starting a second one. -->
                        <kyb-status
                          [applicationId]="trusteeSignerEntity.applicationId"
                          [commercialEntityId]="trusteeSignerEntity.entity.commercialEntityId"
                          [businessName]="trusteeSignerEntity.entity.entityName"
                          [pollFn]="trusteeSignerEntity.pollFn"
                          [refreshFn]="trusteeSignerEntity.refreshFn"
                          (manualEntry)="startManualKyb(trusteeSignerEntity)"
                          (resolved)="signerResolved.emit($event)">
                        </kyb-status>
                      }
                    } @else {
                      <!-- The row's own check has been asked for but its entity is not in the read
                           model yet, so there is nothing to poll on: the panel waits in
                           presentational mode and its Retry re-reads the model, which is what makes
                           the run visible and hands the wait over to the polling panel above. -->
                      <kyb-status
                        [status]="'pending'"
                        [businessName]="signerBusinessName(trusteeFormGroup)"
                        (retry)="signerRetry.emit()">
                      </kyb-status>
                    }
                  </div>
                </div>
              }
            }
            @if (nestedPartyTemplate) {
              <ng-container
                *ngTemplateOutlet="nestedPartyTemplate; context: {$implicit: trusteeFormGroup}">
              </ng-container>
            }
          }
        </div>
      }
    </div>
  }
  @if (allowAddingTrustee) {
    <div class="row separator">
      <div class="col-12">
        <button mat-stroked-button (click)="addTrustee()">
          <span class="mdi mdi-plus" matPrefix></span>
          Add trustee
        </button>
      </div>
    </div>
  }
</div>
